<script>
export default {
  props: {
    textButton: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show
    },
  },
}
</script>

<template>
  <CDropdown
    id="base-drop-down"
    class="c-header-nav-items"
    placement="bottom-start"
    add-menu-classes="pt-0"
    caret
    :show.sync="show"
  >
    <template v-slot:toggler>
      <CButton class="py-0" color="dark" variant="outline">
        {{ $t(textButton) }}
        <font-awesome-icon icon="caret-down" />
      </CButton>
    </template>
    <slot :show="toggleShow"></slot>
  </CDropdown>
</template>
